export default __webpack_public_path__ + "static/media/Talent_ArrowRecovery.faeb8c79.png";